import { render } from "./TextSource.vue?vue&type=template&id=27af2f28&scoped=true&ts=true"
import script from "./TextSource.vue?vue&type=script&lang=ts"
export * from "./TextSource.vue?vue&type=script&lang=ts"

import "./TextSource.vue?vue&type=style&index=0&id=27af2f28&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27af2f28"]])

export default __exports__